export const AUTO_LOGGED_OUT = 'CORE_ACCOUNT/AUTO_LOGGED_OUT';
